module.exports = __webpack_public_path__ + "static/img/card-tzrs.79e7107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/pc/chuangfu/card-tzrs.jpg
// module id = 15
// module chunks = 0